import React from "react";
import "./DisplayGrid.scss";

import SectionTitle from "components/SectionTitle";
import Button from "components/Button";
import ProjectCard from "components/ProjectCard";

const DisplayGrid = ({ title, actions, projects }) => (
  <div className="DisplayGrid">
    <SectionTitle title={title}>
      {actions &&
        actions.map((action, i) => (
          <Button key={i} to={action.to} type={action.type}>
            {action.label}
          </Button>
        ))}
    </SectionTitle>
    <div className="Grid">
      {projects &&
        projects.map((project, i) => {
          return <ProjectCard key={i} {...project} />;
        })}
    </div>
  </div>
);

export default DisplayGrid;
